import React from 'react';
import styled from 'styled-components';

// import StorageService from '../../services/StorageService';

const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
  position: relative;
  display: inline-block;
  width: ${props => props.size.value+props.size.unit};
  height: ${props => props.height ? `${props.height.value}${props.height.unit}` : `${props.size.value}${props.size.unit}`};
  line-height: ${props => props.size.value+props.size.unit};

`;
const Image  = styled.div.withConfig({displayName:'-Image '})`
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: ${props => props.color};
  mask: url("/assets/icons/${props => props.name}.svg") no-repeat 50% 50%;
  mask-size: 100% 100%;

  &:hover{
    background-color: ${props => props.hoverColor};
  }
`;


const Icon = ({
  name = "default",
  color = "#000000",
  hoverColor = color,
  size = "20px"
}) => {
  return (
    <Wrapper size={size}>
      <Image
        name={name}
        color={color}
        hoverColor={hoverColor}
      />
    </Wrapper>
  )
}

export default Icon;
